import Lottie from 'lottie-react';
import styled from 'styled-components/macro';

export const StyledLoginForm = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background: #f9faff;
  display: flex;
  justify-content: center;
  align-items: center;

  .left-side-column {
    width: 50%;

    .images-container {
      position: relative;
      width: 550px;
      height: 360px;
      display: block;
      margin: 0 auto;
      margin-top: 4rem;

      img {
        position: absolute;
        width: 80%;

        &:nth-child(1) {
          width: 70%;
          left: 7%;
          top: 0;
        }
        &:nth-child(2) {
          width: 200px;
          right: -3%;
          top: 7vh;
        }
        &:nth-child(3) {
          width: 300px;
          left: 50%;
          bottom: -5vh;
          z-index: 3;
          transform: translateX(-50%);
        }
      }
    }
  }

  .formContainer {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background: white;
    width: min(100%, 564px);
    margin-left: auto;
    border-radius: 30px;
    padding: 0rem 5rem;
    padding-bottom: 2rem;
    color: rgb(0, 56, 95);
    background: #ffffff;
    box-shadow: 0px 7px 21px rgba(0, 0, 0, 0.03);
    border-radius: 12px;
    animation: boxFadeInAnimation 0.6s ease-out;

    @keyframes boxFadeInAnimation {
      0% {
        transform: translateY(2rem);
        opacity: 0;
      }

      100% {
        transform: translateY(0);
        opacity: 1;
      }
    }

    @keyframes iconSlideAnimation {
      0% {
        transform: translateX(-2rem);
      }

      100% {
        transform: translateX(0);
      }
    }

    h3 {
      font-size: 3.5rem;
      color:#000000;
      text-align:left;
      margin-bottom:0;
    }

    p.subtitle{
      text-align:left;
      color:grey;
      font-size:1.4rem;
      margin-bottom:4rem;
    }

    img {
      width: 12%;
      margin-left: 10%;
      vertical-align: top;
      margin-top: 40px;
      animation: iconSlideAnimation 0.8s ease-out;
    }

    .divider {
      display: inline-block;
      width: 2px;
      height: 19rem;
      background: rgb(0, 56, 95);
      margin-left: 9%;
    }

    .inputHolder {
      display: inline-block;
      vertical-align: top;
      background: white;
      width: 100%;
      text-align: center;

      svg {
        width: fit-content;

        &.pointer{
        cursor:pointer;
      }
      }

      h4 {
        font-size: 2rem;
        margin: 0;
        padding: 0;
        text-align: left;
      }
      .form-group {
        position: relative;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        margin: 2rem auto;
        label {
          color: #969ba0;
        }
      }

      .formInput {
        font-size: 1.5rem;
        border: 1px solid rgb(0, 56, 95);
        display: inline-block;
        display: flex;
        width: 100%;
        padding: 1rem;
        margin-top: 1rem;
        border-radius: 5px;
        background: #f3f4f6;
        border: 0;
        
        &.error{
        background: rgba(255, 227, 231, 0.7);
      }

        input {
          border: none;
          font-size: 1.5rem;
          width: min(40vw, 300px);
          outline: none;
          background: transparent;

          
        }

        input::-ms-reveal,
        input::-ms-clear {
          display: none;
        }
      }

      .buttonHolder {
        position: relative;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        /* width: calc(min(40vw, 300px) + 4rem); */
        width: 100%;
        margin: auto;
        margin-top: 2rem;
        
        font-size: 1.3rem;

        .loginError {
          position: absolute;
          font-size: 1.4rem;
          color: #c44900;
          right:0;
          top:.5rem;
        }
      }

      .error-message{
        position: absolute;
        color:#861724;
        bottom:-58%;
        right:0;

        &.password{
          bottom:-20%;
        }
      }

      button {
        float: right;
        border: none;
        color: white;
        font-size: 1.4rem;
        /* padding: 1rem 3rem; */
        border-radius: 9px;
        width:100%:
        cursor: pointer;

        &:hover {
          background-color: rgb(7, 162, 229);
        }
      }
    }
    .forgot-password-text {
      text-align: left;
      margin-right:auto;
      margin-top: 2.5rem;
    }
  }
`;

export const StyledLottie = styled(Lottie)`
  max-width: 5rem;
  display: inline-block;
  float: right;
`;
